import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router';
import Routes from './routes.js';

/**
/**
 * Creates and configures the Vue Router instance
 * @param {boolean} isSSR - whether the app is being created for server-side rendering (SSR)
 * @returns {import('vue-router').Router} - the configured Vue Router instance
 */
export async function createAppRouter(isSSR = false) {
  const options = {
    history: isSSR ? createMemoryHistory() : createWebHistory(),
    routes: Routes,
  };

  if (!isSSR) {
    const { default: scrollBehavior } = await import('./scrolling.js');
    options.scrollBehavior = scrollBehavior;
  }

  return createRouter(options);
}

export default createAppRouter;
